import axios from "axios";
import { awsUrl } from "../../axiosInstance";

export const getListOfNewImage = () => {
  return axios.get(`${awsUrl}/v1/products/newImg`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};
